import React from 'react';
import { Nullable } from '../../models';
import { DiscountProgramModel } from './discountProgram.model';

export const DiscountProgramContext =
  React.createContext<Nullable<DiscountProgramModel>>(null);
